const demandbasePaths = [
  '/',
  '/partnerships-employers/',
  '/partnerships-health-plans/',
  '/partnerships-health-systems/',
  '/partnerships-pcp/'
]

export const demandbase = (): void => {
  // COMMENT OUT IF NEEDED TO TEST IN DEVELOPMENT
  if (process.env.NODE_ENV !== 'development') {
    if (demandbasePaths.includes(window.location.pathname)) {
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.async = true
      script.innerHTML = `
        (function(d,b,a,s,e){ var t = b.createElement(a),
        fs = b.getElementsByTagName(a)[0]; t.async=1; t.id=e; t.src=s;
        fs.parentNode.insertBefore(t, fs); })
        (window,document,'script','https://tag.demandbase.com/82b146abb98578eb.min.js','demandbase_js_lib');
      `

      document.head.appendChild(script)
    }
  }
}
